import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import { master_general_information_fields } from "../data";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";

function MasterGeneralInformation({ value, setValue }) {
	return (
		<Box p={3} width="90%">
			<Divider>
				<Typography variant="h6">General Information</Typography>
			</Divider>
			<Box display="flex" columnGap={"2%"} rowGap="10px" flexWrap="wrap" width={"100%"} justifyContent={"space-around"}>
				{master_general_information_fields?.map((row) => {
					return (
						<RenderInputField
							column={row}
							data={value}
							setData={setValue}
							width="32%"
							selectOptObjName={"option_data"}
							key={row.key}
						/>
					);
				})}
			</Box>
		</Box>
	);
}

export default MasterGeneralInformation;
